module.exports = __webpack_public_path__ + "static/img/sd.77d124d.png";


//////////////////
// WEBPACK FOOTER
// ./static/imgV2/sd.png
// module id = MjA2
// module chunks = 1